import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import {
    createBrowserRouter,
    RouterProvider,
} from "react-router-dom";
import GrievancePortal from './routes/Grievance/grievancePortal';
import Grievance, { loader as gLoader } from './routes/Grievance/grievance';
import { Authentication } from './Auth/authHOC';
import NotFound from './components/layout/NotFound';
import Search from './routes/Grievance/search/search';
import SearchGrid from './routes/Grievance/search/searchGrid';
import Invoices from './routes/Billing/invoices';
import ReimbursementList from './routes/Reimbursement/reimbursementList';
import FWATrips from './routes/Reservation/fwaTrips';
import BusPassAssignment from './routes/Reservation/busPassAssignment';
import Legal from './routes/Grievance/legalsearch/legalsearch';
import CobDenailInvoices from './routes/Billing/CobDenials/cobDenialInvoices';
import CobPayers from './routes/Billing/CobPayers/cobPayers';
import Facilities from './routes/Facility/facilities';
import CobDenialInvoicePaymentFiles from './routes/Billing/CobDenials/cobDenialInvoicePaymentFiles';
import AddRetractionRequest from './routes/Billing/VendorPayment/AddRetractionRequest';
import ApproveRetractionRequest from './routes/Billing/VendorPayment/ApproveRetractionRequest';
import ImportPaymentFile from './routes/Billing/VendorPayment/ImportPaymentFile';
import Reports from './routes/Reports/reports';
import ReportConfiguration from './routes/Reports/ReportConfiguration';
import ReportConfigurationPreview from './routes/Reports/ReportConfigurationPreview';
import ComplaintBatchUpload from './routes/Grievance/BatchUpload/batchupload';

import Payment835Files from './routes/Billing/Payment835/Payment835Files';
import AppVersions from './routes/AppVersions/appVersions';

const router = createBrowserRouter([
    {
        path: "/",
        element: <App />,
        children: [
            {
                path: "/grievances",
                element: (<GrievancePortal />),
                shouldRevalidate: ({ currentUrl, nextUrl }) => {
                    return !nextUrl.pathname.toString().includes("create") || nextUrl.pathname === "/"                // revalidate parent page
                        || currentUrl.pathname !== nextUrl.pathname; // on any path change
                }
            },
            {
                path: "/grievances/:id",
                element: (<Grievance />),
                loader: gLoader,
            },
            {
                path: "/grievances/create",
                element: (<Grievance type="create" />)
            },
            {
                path: "/complaints/search",
                element: (<Search />)
            },
            {
                path: "/legal/search",
                element: (<Legal />)
            },
            {
                path: "/ClientInvoices/Invoice",
                element: (<Invoices />)
            },
            {
                path: "/ClientInvoices/Invoice/:clientId/:invoiceSid",
                element: (<Invoices />)
            },
            {
                path: "/CobDenialInvoices/Invoice",
                element: (<CobDenailInvoices />)
            },            
            {
                path: "/CobPayers/CobPayer",
                element: (<CobPayers />)
            },
            {
                path: "/Admin/Facility",
                element: (<Facilities />)
            },
            {
                path: "/ClientInvoices/Reimbursement",
                element: (<ReimbursementList />)
            },           
            {
                path: "/Reservation/Reservation/FWATrips",
                 element: (<FWATrips />)
            },
            {
                path: "/Reservation/Reservation/BusPassAssignment",
                element: (<BusPassAssignment />)
            },
            {
                path: "/CobDenialInvoices/PaymentFiles",
                element: (<CobDenialInvoicePaymentFiles />)
            },
            {
                path: "/VendorInvoices/AddRetractionRequest",
                element: (<AddRetractionRequest/>)
            },
            {
                path: "/VendorInvoices/ApproveRetractionRequest",
                element: (<ApproveRetractionRequest/>)
            },
            {
                path: "/VendorInvoices/PaymentFiles",
                element: (<ImportPaymentFile />)
            },
            {
                path: "/SSRS/Reports",
                element: (<Reports />)
            },
            {
                path: "/Reports/ReportConfiguration",
                element: (<ReportConfiguration />)
            },
            {
                path: "/Reports/ReportConfiguration/Preview",
                element: (<ReportConfigurationPreview />)
            },
            {
                path: "/Reports/ReportConfiguration/Preview/:reportId",
                element: (<ReportConfigurationPreview />)
            },
            
            {
                path: "/ClientInvoices/835PaymentFiles",
                element: (<Payment835Files />)
            },
            {
                path: "/Complaints/OfflineBatchUpload",
                element: (<ComplaintBatchUpload />)
            },
            {
                path: "/App/Versions",
                element: (<AppVersions />)
            },
            {
                path: "*",
                element: <NotFound />
            }
        ],
    },
]);

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <Authentication><RouterProvider router={router} /></Authentication>
    </React.StrictMode>
)
